import DestacatBasic from 'components/corporatiu/Destacat/DestacatBasic';
import __isEmpty from 'lodash/isEmpty';
import styles from '../itemsresultatcerca.module.scss';

const ItemResultatGeneral = (props) => {
    const { item, searchParams } = props;
    const { searchProfile } = searchParams;
    const { tipologia, programes_tv, programes_radio, durada } = item || {};

    const _getAvantitol = () => {
        if (!['portalunic', 'videos', 'audios'].includes(searchProfile) && !__isEmpty(searchProfile)) return false;
        switch (tipologia) {
            case 'DTY_VIDEO_MM':
                return programes_tv?.[0]?.titol || programes_radio?.[0]?.titol;
            case 'WCR_AUDIO_MM':
                return programes_radio?.[0]?.titol || programes_tv?.[0]?.titol;
            case 'NOT_NOTICIA':
                if (programes_tv?.[0]?.desc || programes_radio?.[0]?.desc)
                    return `Notícia - ${programes_tv?.[0]?.desc || programes_radio?.[0]?.desc}`;
                return 'Notícia';
            case 'PTVC_PROGRAMA':
            case 'WCR_PROGRAMA':
                return 'Programa';
            default:
                return false;
        }
    };
    const _getDurada = () => {
        const _sliceDurada = (durada) => {
            if (durada.length === 11) {
                durada = durada.slice(0, 8);
            }
            return durada;
        };

        switch (tipologia) {
            case 'DTY_VIDEO_MM':
            case 'WCR_AUDIO_MM':
                if (durada) return _sliceDurada(durada);
                return false;
            default:
                return false;
        }
    };

    return (
        <article>
            <DestacatBasic
                item={{
                    ...item,
                    avantitol: _getAvantitol(),
                    ...(tipologia === 'DTY_VIDEO_MM' && { videos: true }),
                    ...(tipologia === 'WCR_AUDIO_MM' && { audios: true })
                }}
                className={styles.itemResultatGeneral}
                mostrarData={true}
                mostrarEntradeta={true}
                mostrarImatge={true}
                tipusImatge={'web_cercador'}
                mostrarAvantitol={!!_getAvantitol()}
                durada={_getDurada()}
                disposicio='horitzontal'
                estil='gridCercador'
                retallarEntradeta={true}
            />
        </article>
    );
};

export default ItemResultatGeneral;
